module.exports = "pegasus_template/assets/social_follow_library_block.png";